module.exports = (__webpack_require__(4))(1373);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/axios/index.js from dll-reference vendorProd_library
// module id = 247
// module chunks = 42